export default function (initialDataInteractor) {
  let organizations = [];
  initialDataInteractor.data.organizations.forEach(function (organization) {
    let members = [];
    organization.members.forEach(function (person) {
      members.push(person);
    });

    let newOrganization = {
      'id': organization.organization_info.id,
      'name': organization.organization_info.name,
      'members': members
    };
    organizations.push(newOrganization);
  });
  return organizations;
}